import { render, staticRenderFns } from "./IconSepa.vue?vue&type=template&id=2e684a8c&scoped=true&"
import script from "./IconSepa.vue?vue&type=script&lang=js&"
export * from "./IconSepa.vue?vue&type=script&lang=js&"
import style0 from "./IconSepa.vue?vue&type=style&index=0&id=2e684a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e684a8c",
  null
  
)

export default component.exports